import script from "./Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal.vue?vue&type=script&setup=true&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=599f5d8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-599f5d8d"]])

export default __exports__